module.exports = __webpack_public_path__ + "img/logo.d1fa46fb.png";